import {
  AddNotification,
  RemoveAllNotifications,
  RemoveNotificationById,
  ReadAllNotifications,
  ReadNotificationsById,
  AddToastNotification,
  ShowToast,
  RemoveToastNotification,
} from '@/constants/mutations';
import { GetNotifications } from '@/constants/getters';
import {
  ClearAllNotifications,
  ClearNotificationById,
  MarkAllNotificationsAsRead,
  MarkNotificationAsReadById,
} from '@/constants/actions';

const defaultState = () => {
  return {
    toasts: [],
    notifications: [],
  };
};

export const state = defaultState;

export const mutations = {
  [AddNotification](state, notification) {
    const itemIndex = (state.notifications || []).findIndex((n) => n.id === notification.id);

    if (itemIndex === -1) {
      state.notifications = [notification, ...state.notifications];
    }
  },

  [AddToastNotification](state, toast) {
    const itemIndex = (state.toasts || []).findIndex((t) => t.id === toast.id);

    if (itemIndex === -1) {
      state.toasts = [toast, ...state.toasts];
    }
  },

  [ShowToast](state, id) {
    const index = state.toasts.findIndex((t) => t.id === id);

    if (index < 0) {
      return;
    }

    const copy = [...state.toasts];
    copy[index].opened = true;
    state.toasts = copy;
  },

  [RemoveToastNotification](state, id) {
    const index = state.toasts.findIndex((t) => t.id === id);

    if (index < 0) {
      return;
    }

    const copy = [...state.toasts];
    copy.splice(index, 1);
    state.toasts = copy;
  },

  [RemoveAllNotifications](state) {
    state.notifications = [];
  },

  [RemoveNotificationById](state, notificationId) {
    state.notifications = (state.notifications || []).filter((n) => n.id !== notificationId);
  },

  [ReadAllNotifications](state) {
    const readAt = new Date().toISOString();
    state.notifications = (state.notifications || []).map((n) => ({ ...n, readAt }));
  },

  [ReadNotificationsById](state, notificationId) {
    const itemIndex = (state.notifications || []).findIndex((n) => n.notificationId === notificationId);

    if (itemIndex !== -1) {
      state.notifications[itemIndex] = { ...state.notifications[itemIndex], readAt: new Date().toISOString() };
    }
  },
};

export const getters = {
  [GetNotifications](state) {
    return state.notifications;
  },
};

export const actions = {
  [AddToastNotification]: ({ commit }, toast) => {
    commit(AddToastNotification, toast);

    /**
     * Allowing the enter animation to take place
     * on the bb toast message component.
     */
    setTimeout(() => {
      commit(ShowToast, toast.id);
    }, 500);

    /**
     * Allowing the exit animation to take place
     * on the bb toast message component.
     */
    if (toast.duration >= 0) {
      setTimeout(() => {
        commit(RemoveToastNotification, toast.id);
      }, parseInt(toast.duration) + 500);
    }
  },

  [AddNotification]: ({ commit }, notification) => {
    commit(AddNotification, notification);
  },

  [ClearAllNotifications]({ commit }) {
    this.$realtime.publishToUserChannel({
      channel: 'notifications:update',
      topic: 'clear',
      message: {},
    });
    commit(RemoveAllNotifications);
  },

  [ClearNotificationById]({ commit }, notificationId) {
    this.$realtime.publishToUserChannel({
      channel: 'notifications:update',
      topic: 'clear',
      message: { ids: [notificationId] },
    });
    commit(RemoveNotificationById, notificationId);
  },

  [MarkAllNotificationsAsRead]({ commit }) {
    this.$realtime.publishToUserChannel({
      channel: 'notifications:update',
      topic: 'read',
      message: {},
    });
    commit(ReadAllNotifications);
  },

  [MarkNotificationAsReadById]({ ctx, commit }, notificationId) {
    this.$realtime.publishToUserChannel({
      channel: 'notifications:update',
      topic: 'read',
      message: { ids: [notificationId] },
    });
    commit(ReadNotificationsById, notificationId);
  },
};
